/* theme.cart.js — split verbatim from Shrine main.js (deobfuscated 2026-10-14).
   Load order: theme.core → theme.cart → theme.search → theme.product → theme.deals → theme.extras → theme.license-guard. */

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", event => {
      event.preventDefault();
      if (this.dataset.handle) {
        const handle = this.dataset.handle,
          els = document.querySelectorAll(".quantity-break__upsell[data-handle=\"" + handle + "\"]");
        els.forEach(item => {
          item.dataset.selected = "false";
          item.classList.remove("quantity-break__upsell--selected");
          const el = item.querySelector("input[type=\"checkbox\"]");
          if (el) el.checked = false;
        });
      }
      const parentEl = this.closest("cart-items") || this.closest("cart-drawer-items");
      this.clearCart ? parentEl.clearCart() : parentEl.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = formatDates(currentDate, date);
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    this.quantityGifts = document.querySelector(".quantity-gifts");
    const debounceResult = debounce(arg => {
      this.onChange(arg);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", debounceResult.bind(this));
    this.isCartPage = this.nodeName === "CART-ITEMS";
    this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : "cart-items";
    this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
    if (this.hasOtherCartItems) {
      if (this.isCartPage) initShrineGiftsCheck(true);
    } else initShrineGiftsCheck(false);
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, arg => {
      if (arg.source === "cart-items") return;
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(arg) {
    this.updateQuantity(arg.target.dataset.index, arg.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(result => result.text()).then(result => {
      const parseFromString = new DOMParser().parseFromString(result, "text/html"),
        el = parseFromString.querySelector("cart-items");
      this.innerHTML = el.innerHTML;
    })["catch"](arg => {
      console.error(arg);
    });
  }
  updateCart() {
    const json = JSON.stringify({
      sections: this.getSectionsToRender().map(item => item.section),
      sections_url: window.location.pathname
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: json
    }).then(result => result.json()).then(result => {
      this.classList.toggle("is-empty", result.item_count === 0);
      this.getSectionsToRender().forEach(item => {
        const el = document.getElementById(item.id).querySelector(item.selector) || document.getElementById(item.id);
        el.innerHTML = this.getSectionInnerHTML(result.sections[item.section], item.selector);
      });
    })["catch"](arg => {
      console.error(arg);
    });
  }
  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  async updateQuantity(arg, arg2, arg3) {
    this.enableLoading(arg);
    const el = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (el) el.textContent = "";
    const json = JSON.stringify({
      line: arg,
      quantity: arg2,
      sections: this.getSectionsToRender().map(item => item.section),
      sections_url: window.location.pathname
    });
    try {
      const response = await fetch("" + routes.cart_change_url, {
          ...fetchConfig(),
          ...{
            body: json
          }
        }),
        text = await response.text(),
        data = JSON.parse(text),
        el2 = document.getElementById("Quantity-" + arg) || document.getElementById("Drawer-quantity-" + arg),
        els = document.querySelectorAll(".cart-item");
      if (data.errors) {
        el2.value = el2.getAttribute("value");
        this.updateLiveRegions(arg, data.errors);
        return;
      }
      if (!data.sections) {
        const response2 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(item => item.section).join(","));
        data.sections = await response2.json();
      }
      this.classList.toggle("is-empty", data.item_count === 0);
      const el3 = document.querySelector("cart-drawer"),
        el4 = document.getElementById("main-cart-footer");
      if (el4) el4.classList.toggle("is-empty", data.item_count === 0);
      if (el3) el3.classList.toggle("is-empty", data.item_count === 0);
      this.getSectionsToRender().forEach(item => {
        const el6 = document.getElementById(item.id);
        if (el6) {
          const el7 = el6.querySelector(item.selector) || el6;
          el7.innerHTML = this.getSectionInnerHTML(data.sections[item.section], item.selector);
          const el8 = el7.querySelector(".cart-drawer__body");
          if (el8 && this.cartDrawer) el8.scrollTop = this.cartDrawer.cartBodyScroll;
        }
      });
      const quantity = data.items[arg - 1] ? data.items[arg - 1].quantity : undefined;
      let str = "";
      els.length === data.items.length && quantity !== parseInt(el2.value) && (typeof quantity === "undefined" ? str = window.cartStrings.error : str = window.cartStrings.quantityError.replace("[quantity]", quantity));
      this.updateLiveRegions(arg, str);
      const el5 = document.getElementById("CartItem-" + arg) || document.getElementById("CartDrawer-Item-" + arg);
      if (el5 && el5.querySelector("[name=\"" + arg3 + "\"]")) el3 ? trapFocus(el3, el5.querySelector("[name=\"" + arg3 + "\"]")) : el5.querySelector("[name=\"" + arg3 + "\"]").focus();else {
        if (data.item_count === 0 && el3) trapFocus(el3.querySelector(".drawer__inner-empty"), el3.querySelector("a"));else document.querySelector(".cart-item") && el3 && trapFocus(el3, document.querySelector(".cart-item__name"));
      }
      if (el3) {
        el3.checkForClear();
        const el6 = el3.querySelector("countdown-timer");
        if (el6) el6.playTimer();
        let flag = false;
        if (el3.querySelector("cart-drawer-gift")) {
          el3.checkForClear();
          let arr = [],
            arr2 = [];
          el3.querySelectorAll("cart-drawer-gift").forEach(item => {
            item.getUpdateRequired() && (el3.querySelector(".cart-item--product-" + item.dataset.handle) ? item.dataset.selected === "false" && arr2.push(item) : item.dataset.selected === "true" && arr.push(item));
          });
          if (arr2.length > 0) {
            flag = true;
            arr2[0].removeFromCart();
          } else arr.length > 0 && (flag = true, arr[0].addToCart());
        }
        this.quantityGifts && !flag && this.quantityGifts.initUnlock();
        const els2 = document.querySelectorAll("quantity-break-upsells");
        els2.forEach(item => {
          if (!flag) item.initUnlock();
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: data
      });
    } catch (error) {
      console.log(error);
      this.querySelectorAll(".loading-overlay").forEach(item => item.classList.add("hidden"));
      const el2 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      el2.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(arg);
      if (this.secondCartItems && this.secondCartItems.updateCart) this.secondCartItems.updateCart();
      const customEvent = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle"
        }
      });
      document.dispatchEvent(customEvent);
      if (shouldCheckShrineGifts) checkShrineGifts(this.isCartPage);
      validateCartGifts(this.isCartPage);
    }
  }
  updateLiveRegions(arg, arg2) {
    const el = document.getElementById("Line-item-error-" + arg) || document.getElementById("CartDrawer-LineItemError-" + arg);
    if (el) el.querySelector(".cart-item__error-text").innerHTML = arg2;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const el2 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    el2.setAttribute("aria-hidden", false);
    setTimeout(() => {
      el2.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(arg, arg2) {
    return new DOMParser().parseFromString(arg, "text/html").querySelector(arg2).innerHTML;
  }
  enableLoading(arg) {
    const el = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    el.classList.add("cart__items--disabled");
    const els = this.querySelectorAll("#CartItem-" + arg + " .loading-overlay"),
      els2 = this.querySelectorAll("#CartDrawer-Item-" + arg + " .loading-overlay");
    [...els, ...els2].forEach(item => item.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(arg) {
    const el = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    el.classList.remove("cart__items--disabled");
    const els = this.querySelectorAll("#CartItem-" + arg + " .loading-overlay"),
      els2 = this.querySelectorAll("#CartDrawer-Item-" + arg + " .loading-overlay");
    els.forEach(item => item.classList.add("hidden"));
    els2.forEach(item => item.classList.add("hidden"));
  }
  clearCart() {
    const el = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (el) el.textContent = "";
    const json = JSON.stringify({
      sections: this.getSectionsToRender().map(item => item.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: json
      }
    }).then(result => {
      return result.text();
    }).then(async result => {
      const data = JSON.parse(result);
      if (!data.sections) try {
        const joined = this.getSectionsToRender().map(item => item.id).join(","),
          response = await fetch(routes.cart_url + "?sections=" + joined),
          text = await response.text();
        try {
          const data2 = JSON.parse(text);
          data.sections = data2;
        } catch (error) {
          console.error("Clear cart fallback JSON parse failed", error);
          window.location.reload();
          return;
        }
      } catch (error) {
        console.error("Clear cart fallback failed", error);
        throw error;
      }
      this.classList.add("is-empty");
      const el2 = document.querySelector("cart-drawer"),
        el3 = document.getElementById("main-cart-footer");
      if (el3) el3.classList.add("is-empty");
      if (el2) el2.classList.add("is-empty");
      this.getSectionsToRender().forEach(item => {
        const el4 = document.getElementById(item.id).querySelector(item.selector) || document.getElementById(item.id);
        el4.innerHTML = this.getSectionInnerHTML(data.sections[item.section], item.selector);
      });
      el2 && trapFocus(el2.querySelector(".drawer__inner-empty"), el2.querySelector("a"));
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
      if (shouldCheckShrineGifts) checkShrineGifts(this.isCartPage);
    })["catch"](() => {
      this.querySelectorAll(".loading-overlay").forEach(item => item.classList.add("hidden"));
      const el2 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      el2.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
!customElements.get("cart-note") && customElements.define("cart-note", class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", debounce(arg => {
      const json = JSON.stringify({
        note: arg.target.value
      });
      fetch("" + routes.cart_update_url, {
        ...fetchConfig(),
        ...{
          body: json
        }
      });
    }, ON_CHANGE_DEBOUNCE_TIMER));
  }
});
function handleDiscountForm(event) {
  event.preventDefault();
  const el = event.target.querySelector("[name=cart-discount-field]"),
    el2 = event.target.querySelector(".cart-discount-form__error"),
    value = el.value;
  if (value === undefined || value.length === 0) {
    el2.style.display = "block";
    return;
  }
  el2.style.display = "none";
  const str = "/checkout?discount=",
    value2 = str + value;
  window.location.href = value2;
}
function handleDiscountFormChange(arg) {
  const els = document.querySelectorAll(".cart-discount-form__error");
  els.forEach(item => {
    item.style.display = "none";
  });
}
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.quantityGifts = document.querySelector(".quantity-gifts");
    this.checkForClear();
    this.addEventListener("keyup", event => event.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartBodyScroll = 0;
  }
  setHeaderCartIconAccessibility() {
    let el = document.querySelector("#cart-icon-bubble");
    if (!el) return;
    if (el.tagName == "DIV") el = el.closest(".header__icon--cart");
    if (!el) return;
    const parentEl = el.closest(".header__icons");
    el.setAttribute("role", "button");
    el.setAttribute("aria-haspopup", "dialog");
    el.addEventListener("click", event => {
      event.preventDefault();
      this.open(el);
    });
    this.oseid = parentEl.querySelector("form").dataset[this.dataset.type];
    el.addEventListener("keydown", event => {
      event.code.toUpperCase() === "SPACE" && (event.preventDefault(), this.open(el));
    });
  }
  open(arg) {
    if (arg) this.setActiveElement(arg);
    const el = this.querySelector("[id^=\"Details-\"] summary");
    if (el && !el.hasAttribute("role")) this.setSummaryAccessibility(el);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const el3 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
        el4 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(el3, el4);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    const el2 = this.querySelector("countdown-timer");
    if (el2) el2.playTimer();
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const els = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift"),
      arr = [];
    els.forEach(item => {
      item.dataset.handle && arr.push(item.dataset.handle);
    });
    return arr;
  }
  oneNonUpellRemaining() {
    const els = this.querySelectorAll(".cart-item");
    let num = 0;
    els.forEach(item => {
      this.upsellHandles.forEach(item2 => {
        item.classList.contains("cart-item--product-" + item2) && num++;
      });
    });
    return els.length - num <= 1;
  }
  checkForClear() {
    const oneNonUpellRemaining = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(item => {
      oneNonUpellRemaining ? item.clearCart = true : item.clearCart = false;
    });
  }
  setSummaryAccessibility(el) {
    el.setAttribute("role", "button");
    el.setAttribute("aria-expanded", "false");
    el.nextElementSibling.getAttribute("id") && el.setAttribute("aria-controls", el.nextElementSibling.id);
    el.addEventListener("click", event => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });
    el.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(arg, arg2 = false) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = arg.id;
    this.getSectionsToRender().forEach(item => {
      const el2 = item.selector ? document.querySelector(item.selector) : document.getElementById(item.id);
      if (el2) {
        el2.innerHTML = this.getSectionInnerHTML(arg.sections[item.id], item.selector);
        const el3 = el2.querySelector(".cart-drawer__body");
        if (el3) el3.scrollTop = this.cartBodyScroll;
      }
    });
    this.checkForClear();
    const el = this.querySelector("countdown-timer");
    if (el && el.playTimer) el.playTimer();
    let arr = [],
      arr2 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(item => {
      item.getUpdateRequired() && (this.querySelector(".cart-item--product-" + item.dataset.handle) ? item.dataset.selected === "false" && arr2.push(item) : item.dataset.selected === "true" && arr.push(item));
    });
    if (arr2.length > 0) arr2[0].removeFromCart();else {
      if (arr.length > 0) arr[0].addToCart();else {
        if (this.quantityGifts) this.quantityGifts.initUnlock();
        const els = document.querySelectorAll("quantity-break-upsells");
        els.forEach(item => {
          item.initUnlock();
        });
      }
    }
    validateCartGifts();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (arg2) return;
      this.open();
    });
  }
  getSectionInnerHTML(arg, arg2 = ".shopify-section") {
    let el = new DOMParser().parseFromString(arg, "text/html").querySelector(arg2);
    arg2 === "#CartDrawer" && fixParsedHtml(this, el);
    let html = el.innerHTML;
    return html;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM(arg, arg2 = ".shopify-section") {
    return new DOMParser().parseFromString(arg, "text/html").querySelector(arg2);
  }
  setActiveElement(arg) {
    this.activeElement = arg;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(result => result.json()).then(result => {
      document.querySelector("cart-drawer").renderContents(result, true);
    })["catch"](arg => {
      console.error(arg);
    });
  }
  getSectionInnerHTML(arg, arg2) {
    let el = new DOMParser().parseFromString(arg, "text/html").querySelector(arg2);
    arg2 === ".drawer__inner" && fixParsedHtml(this.cartDrawer, el);
    let html = el.innerHTML;
    return html;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(el, el2) {
  const el3 = el.querySelector(".cart-drawer__body");
  if (el3) {
    const el5 = document.querySelector("cart-drawer");
    el5.cartBodyScroll = el3.scrollTop;
  }
  const el4 = el2.querySelector(".cart-timer");
  if (el4) {
    oldTimer = el.querySelector(".cart-timer");
    if (oldTimer) el4.innerHTML = oldTimer.innerHTML;
  }
  const els = el.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let els2 = el2.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  els.forEach((item, index) => {
    let item2 = els2[index];
    if (!item2) return;
    if (item.nodeName.toLowerCase() === "cart-drawer-upsell") item2.dataset.selected = item.dataset.selected;
    item2.dataset.id = item.dataset.id;
    item2.querySelector("[name=\"id\"]").value = item.querySelector("[name=\"id\"]").value;
    if (item2.querySelector(".upsell__image__img")) item2.querySelector(".upsell__image__img").src = item.querySelector(".upsell__image__img").src;
    if (item2.querySelector(".upsell__variant-picker")) {
      const els3 = item.querySelectorAll(".select__select");
      item2.querySelectorAll(".select__select").forEach((item3, index2) => {
        item3.value = els3[index2].value;
        item3.querySelectorAll("option").forEach(item4 => {
          item4.removeAttribute("selected");
          if (item4.value === els3[index2].value.trim()) item4.setAttribute("selected", "");
        });
      });
    }
    if (item.dataset.updatePrices === "true") {
      var el5 = item2.querySelector(".upsell__price"),
        el6 = item.querySelector(".upsell__price");
      if (el5 && el6) el5.innerHTML = el6.innerHTML;
    }
  });
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(item => item.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(arg) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const value = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (value !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const parseIntResult = parseInt(this.input.value);
    if (this.input.min) {
      const parseIntResult2 = parseInt(this.input.min),
        el = this.querySelector(".quantity__button[name='minus']");
      el.classList.toggle("disabled", parseIntResult <= parseIntResult2);
    }
    if (this.input.max) {
      const parseIntResult2 = parseInt(this.input.max),
        el = this.querySelector(".quantity__button[name='plus']");
      el.classList.toggle("disabled", parseIntResult >= parseIntResult2);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) this.quantityGifts.unlockGifts(parseIntResult);
  }
}
customElements.define("quantity-input", QuantityInput);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code).then(result => {
      if (!result.ok) throw new Error("Error");
      this.dataset.applied = "true";
      sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    })["catch"](arg => {
      this.dataset.error = "true";
      this.button.disabled = false;
    })["finally"](() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const code = this.dataset.code;
    sessionStorage.getItem("discount-" + code + "-applied") && (this.dataset.applied = "true", this.button.disabled = true, setTimeout(() => {
      fetch("/discount/" + code)["catch"](arg => {
        this.dataset.applied = "false";
        this.button.disabled = false;
      });
    }, 3000));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
